module.exports = __webpack_public_path__ + "static/media/bg2.875afece.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/bg2.png
// module id = 1616
// module chunks = 0